export default __webpack_public_path__ + "static/media/times_up.3722249a.mp3";